const exchangeRates = {
  USD: {
    RWF: 1132.50,
    GBP: 0.73,
    JPY: 110.94,
    GNF: 8655,
  },
  RWF: {
    USD: 0.00088,
    GBP: 0.85,
    JPY: 129.24,
    GNF: 7.64,
  },
  GBP: {
    USD: 1.37,
    EUR: 1.18,
    JPY: 151.76,
    GNF: 18500,
  },
  JPY: {
    USD: 0.009,
    EUR: 0.008,
    GBP: 0.007,
    GNF: 75000,
  },
  GNF: {
    USD: 0.00012,
    GBP: 0.058,
    JPY: 0.67,
    RWF: 0.13,
  },
};

export default exchangeRates;
